import { render, staticRenderFns } from "./offer-more-content.vue?vue&type=template&id=54aa8102&scoped=true"
import script from "./offer-more-content.vue?vue&type=script&lang=js"
export * from "./offer-more-content.vue?vue&type=script&lang=js"
import style0 from "./offer-more-content.vue?vue&type=style&index=0&id=54aa8102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa8102",
  null
  
)

export default component.exports